import { isUndefined, omitBy } from 'lodash';
/*
 * https://github.com/croquiscom/fbk-web/blob/master/util/app_utils.ts 에서 가져옴
  - subl
  - back
  - close
  - updateCart
 */

declare global {
  interface Window {
    fbk?: FbkAppInterface;
    webkit: any;
  }
}

// eslint-disable-next-line @typescript-eslint/ban-types
type ArgumentTypes<F extends Function> = F extends (args: infer A) => any ? A : never;

interface FbkAppInterface {
  subl(props: { log: Record<string, any> }): void;
  back(): void;
  close(): void;
  updateCart(): void;
}

function isExistAppInterface() {
  if (typeof window === 'undefined') {
    return false;
  }
  const aos_interface = window.fbk;
  const ios_interface = window.webkit?.messageHandlers?.fbk?.postMessage;

  return aos_interface || ios_interface;
}

function callAppInterface<T extends keyof FbkAppInterface>(app_func_name: T, args?: ArgumentTypes<FbkAppInterface[T]>) {
  if (!isExistAppInterface()) {
    console.warn('앱에서 실행할 수 있습니다.');
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  try {
    const aos_interface = window.fbk;

    if (aos_interface) {
      const getAosParams = () => {
        if (!args) {
          return [];
        }

        if (app_func_name === 'subl') {
          return [JSON.stringify(Object.values(args)[0])];
        }

        const is_single_obj_param = typeof args === 'object' && Object.keys(args).length === 1;

        if (is_single_obj_param) {
          return [JSON.stringify(args)];
        }

        return Object.values(args);
      };
      const params = getAosParams();
      // @ts-expect-error @ts-ignore
      aos_interface[app_func_name](...params);
    }

    if (window.webkit?.messageHandlers?.fbk?.postMessage) {
      const ios_props = omitBy(
        {
          name: app_func_name,
          parameters: args ?? undefined,
        },
        isUndefined,
      );

      window.webkit.messageHandlers.fbk.postMessage(ios_props);
      return;
    }
  } catch (error) {
    if (!(error instanceof Error)) {
      return;
    }
    console.error(`[${app_func_name} error]`, error.message);
  }
}

/*
 * ubl 전송
 */
export function fbkSubl(log: Record<string, any>) {
  if (typeof window !== 'undefined') {
    try {
      if (window.fbk) {
        // 로그 긴급대응
        // @ts-expect-error @ts-ignore
        window.fbk.subl(JSON.stringify(log));
      } else if (window.webkit?.messageHandlers?.fbk?.postMessage) {
        window.webkit.messageHandlers.fbk.postMessage({
          name: 'subl',
          parameters: log,
        });
      }
    } catch (error) {
      if (!(error instanceof Error)) {
        return;
      }
      console.log('[subl error]', error.message);
    }
  }
}

/**
 * 현재 액티비티 웹뷰를 바로 닫는다.
 */
export function fbkClose() {
  callAppInterface('close');
}

/**
 * WebView 히스토리 존재 시 history back 수행. 히스토리 미존재 시 현재 Activity/Controller 종료
 */
export function fbkBack() {
  callAppInterface('back');
}

/**
 * 앱에서 장바구니 갯수 갱신 필요시 호출하여 싱크
 */
export function fbkUpdateCart() {
  callAppInterface('updateCart');
}
